import { render, staticRenderFns } from "./cheapest-cab-service-goa.vue?vue&type=template&id=4dac2e73&scoped=true"
import script from "./cheapest-cab-service-goa.vue?vue&type=script&lang=js"
export * from "./cheapest-cab-service-goa.vue?vue&type=script&lang=js"
import style0 from "./cheapest-cab-service-goa.vue?vue&type=style&index=0&id=4dac2e73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac2e73",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
